import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import 'animate.css';

import './kindergarten.scss';

// ここにページの js を記述します

// Slider
const slideshow_swiper = new Swiper('.slideshow-swiper', {
  // Optional parameters
  spaceBetween: 0,
  centeredSlides: true,
  speed: 5000,
  autoplay: {
    delay: 1,
  },
  loop: true,
  slidesPerView: 'auto',
  allowTouchMove: false,
  disableOnInteraction: true,
  freemode: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

// Slider
const parent_swiper = new Swiper('.parent-swiper', {
  // Optional parameters
  spaceBetween: 0,
  slidesPerView: 3,
  loop: true,
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 3,
    },
  },

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

// Find the button with the question
const question = document.getElementsByClassName('question'),
  answer = document.getElementsByClassName('answer');

for (let i = 0; i < question.length; i++) {
  question[i].addEventListener('click', () => {
    answer[i].style.display =
      answer[i].style.display == 'flex' ? 'none' : 'flex';
    answer[i].classList.toggle('is-active');
    question[i].classList.toggle('is-active');
  });
}